"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const PopoverModalForm_1 = require("../../components/PopoverModalForm");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class TwoStepTimePickerContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startTime: null,
            endTime: null,
            currentView: 'startTime',
        };
        this.getPopoverFormInputProps = this.getPopoverFormInputProps.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.updateTempTime = this.updateTempTime.bind(this);
        this.getAddButton = this.getAddButton.bind(this);
        this.getEditButton = this.getEditButton.bind(this);
        this.getPopoverModalProps = this.getPopoverModalProps.bind(this);
        this.getPopoverNavbarProps = this.getPopoverNavbarProps.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    getPopoverFormInputProps() {
        const { device, getDisplayTime } = this.props;
        return {
            id: `automated-start-end-time-picker`,
            label: device !== 'Mobile' ? 'What portion of the day can it be delivered?' : 'Portion of the Day',
            media: device,
            text: getDisplayTime(),
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
            isEditingText: false,
            textMode: true,
        };
    }
    handleOpen() {
        const { startTime, endTime } = this.props;
        const dt = new Date();
        const currentTimeInSeconds = dt.getSeconds() + 60 * dt.getMinutes() + 60 * 60 * dt.getHours();
        this.setState({
            currentView: 'startTime',
            startTime: startTime === null ? currentTimeInSeconds : startTime,
            endTime: endTime === null ? currentTimeInSeconds + 60 : endTime,
        });
    }
    handleClose() {
        this.setState({
            startTime: null,
            endTime: null,
            currentView: 'startTime',
        });
    }
    updateTempTime(seconds) {
        const { currentView } = this.state;
        switch (currentView) {
            case 'startTime':
                this.setState({
                    startTime: seconds,
                });
                break;
            case 'endTime':
                this.setState({
                    endTime: seconds,
                });
                break;
            default:
                break;
        }
    }
    getAddButton() {
        const { device } = this.props;
        switch (device) {
            case 'Desktop':
                return (React.createElement("div", { key: "two-step-time-picker-add" },
                    React.createElement(src_1.Button, { text: "Add", type: "regular", style: {
                            innerStyle: {
                                fontSize: 17,
                            },
                            outerStyle: {
                                height: null,
                                lineHeight: '24px',
                            },
                        }, mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        } })));
            case 'Tablet':
                return React.createElement(src_1.PlusIcon, { key: "two-step-time-picker-add", fill: src_1.titanium });
            default:
                return null;
        }
    }
    getEditButton() {
        const { device } = this.props;
        switch (device) {
            case 'Desktop':
                return (React.createElement(src_1.Button, { text: "Edit", type: "regular", style: {
                        innerStyle: {
                            fontSize: 17,
                        },
                    }, mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, key: "two-step-time-picker-change" }));
            case 'Tablet':
                return React.createElement(src_1.ChangeIcon, { key: "two-step-time-picker-change", fill: src_1.titanium });
            default:
                return null;
        }
    }
    getPopoverNavbarProps(handleClosePopoverModal) {
        const { updateTimeOfDayEventTriggerFilter } = this.props;
        const { startTime, endTime, currentView } = this.state;
        const getButtonRight = () => {
            if (currentView === 'endTime' && startTime > endTime) {
                return '';
            }
            return currentView === 'startTime' ? 'Next' : 'Done';
        };
        const getRightCallback = () => {
            switch (currentView) {
                case 'startTime':
                    this.setState({
                        currentView: 'endTime',
                        endTime: startTime + 60,
                    });
                    break;
                case 'endTime':
                    updateTimeOfDayEventTriggerFilter({
                        startTime,
                        endTime,
                    });
                    this.setState({
                        currentView: 'startTime',
                    });
                    handleClosePopoverModal();
                    break;
                default:
                    break;
            }
        };
        return {
            buttonRight: getButtonRight(),
            buttonRightCallback: getRightCallback,
            buttonLeftCallback: () => {
                this.handleClose();
                handleClosePopoverModal();
            },
            title: currentView === 'startTime' ? 'Start Time' : 'End Time',
        };
    }
    getPopoverModalProps(handleClosePopoverModal) {
        return {
            placement: 'left',
            navBarProperties: Object.assign({ buttonLeft: 'Cancel', id: 'navBarId', style: {
                    containerStyle: {
                        borderRadius: '3px 3px 0px 0px',
                    },
                } }, this.getPopoverNavbarProps(handleClosePopoverModal)),
        };
    }
    handleDelete() {
        this.props.removeEventTriggerFilter('TimeOfDayEventTriggerFilter');
    }
    render() {
        const { device } = this.props;
        const { startTime, endTime, currentView } = this.state;
        return (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: this.getPopoverFormInputProps(), presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: "automated-start-end-time-picker", popoverModalProps: this.getPopoverModalProps, popoverNavbarProps: this.getPopoverNavbarProps, handleShowPopoverForm: this.handleOpen, handleSaveChange: this.handleDelete, addButton: this.getAddButton(), editButton: this.getEditButton() },
            React.createElement("div", { key: "two-step-time-picker-component", style: {
                    padding: device === 'Mobile' ? 24 : 16,
                } },
                React.createElement(src_1.TimePicker, { handleSecondsChange: this.updateTempTime, seconds: currentView === 'startTime' ? startTime || this.props.startTime : endTime, containerStyle: {
                        width: device !== 'Mobile' ? 352 : 'none',
                    } }))));
    }
}
const mapStateToProps = (state) => {
    const eventTriggerFilter = reducers_1.getEditableCampaignTimeOfDayEventTriggerFilter(state);
    return {
        startTime: eventTriggerFilter && eventTriggerFilter.startTime ? eventTriggerFilter.startTime : null,
        endTime: eventTriggerFilter && eventTriggerFilter.endTime ? eventTriggerFilter.endTime : null,
        getDisplayTime: () => reducers_1.getEditableCampaignDisplayTime(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        removeEventTriggerFilter: (filterName) => {
            dispatch(actions_1.removeEventTriggerFilter(filterName));
        },
        updateTimeOfDayEventTriggerFilter: (timeOfDay) => {
            dispatch(actions_1.updateTimeOfDayEventTriggerFilter(timeOfDay));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TwoStepTimePickerContainer);
